import React from "react";
import { makeStyles, tokens } from '@fluentui/react-components';
import AdminSidebar from './AdminSidebar.jsx';

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '220px 1fr',
    gridTemplateRows: '56px 1fr',
    height: '100vh',
    backgroundColor: tokens.colorNeutralBackground3,
  },
  sidebar: {
    gridColumn: '1',
    gridRow: '1 / span 2',
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  topbar: {
    gridColumn: '2',
    gridRow: '1',
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  content: {
    gridColumn: '2',
    gridRow: '1 / span 2',
    overflow: 'auto',
  },
});

export default function AdminAppShell({ children, page, onNavigate }) {
  const s = useStyles();

  return (
    <div className={s.root}>
      <aside className={s.sidebar}>
        <AdminSidebar page={page} onNavigate={onNavigate} />
      </aside>
      <main className={s.content}>{children}</main>
    </div>
  )
}